module.exports = __webpack_public_path__ + "static/media/assolombarda.679ee2bd.png";